import jsStrategy from './jsStrategy';
import StrategyRoot from '@/views/strategy';
import {STRATEGY_ROOT} from '@/enmus/PageNames';

export default {
    path: 'strategy',
    name: 'strategy',
    component: StrategyRoot,
    meta: {
        name: STRATEGY_ROOT,
        title: '策略管理'
    },
    children: [
        jsStrategy
    ]
};

export {JsStrategyHistory} from './jsStrategy';